<!-- 采购验收 -->
<template>
  <div class='page_content'>
    <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
      <zdysListAction v-if="showStatus" ref="zdysListAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></zdysListAction>
    </el-drawer>
    <subComponents ref="showSelectData"></subComponents>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
      </div>
    </div>
    <div class="page_content_center">
      <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
        <el-table-column label="选择操作" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column align="center" v-if="tableValye.isShow == 1" show-overflow-tooltip :min-width="tableValye.fieldWeight" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey"
          :prop="tableValye.entityField" :label="tableValye.showField">
          <template slot-scope="scope">
            <span v-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
              </span>
            </span>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{
                                        scope.row[tableValye.entityField] }}</a>
            </span>
            <el-tag size="mini" v-else-if="tableValye.entityField == 'drtcamState'">
              {{ $common.getIsGsp(tableValye.formatterContent, scope.row.drtcamState) }}</el-tag>
            <span v-else>
              {{ scope.row[tableValye.entityField] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="getSeData" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>
  
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import zdysListAction from "@/components/zdysListAction.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    zdysListAction
  },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      seTitle: "",
      DialogVisible: false,
      seWidth: "",
      seId: "",
      getRequestData: {
        smName: '',
        smId: '',
        page: 1,
        rows: 30,
        start: '',
        end: '',
      },
      returnData: {
        pages: 0,  // 总页数
        total: 0,  // 总条数
        pageNum: 0,  // 当前页数
        list: []
      },
      buttonList: [],

      pageShowData: [],
      formDataList: [],
      selectedDataIndex: 0,
      showStatus: false,
      actionData: [],
      parentSearchData: {},
      sField: '', //赋值字段

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    'getRequestData.smName': {
      handler: function (newValue, oldValue) {
        if (newValue == '') {
          this.getRequestData.pscamBuycus = ''
        }
      },
      deep: true,
    }
  },
  //方法集合
  methods: {
    openSearch({ sId, index, type, sField }) {
      this.seId = sId;
      this.sField = sField
      this.DialogVisible = true;
      this.parentSearchData[type] = this.getRequestData[type]
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.getRequestData[item] = val[item]
      })
    },
    getSeData(val) {
      this.paramValue(val)
      this.DialogVisible = false;
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    // 子组件触发
    drawerCancel(e) {
      this.showStatus = false
      if (e == 1) this.getDataList()
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页    
        var isPenetrate = true
        // 设置缓存 存入点击单号
        this.resetSetItem('penetrateOrderId', orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({  //向窗口发送MessageEvent消息
          cmd: 'returnFormJson',
          params: { isPenetrate } //参数
        }, '*');
      }
    },
    isShowData(name, value) {
      console.log(name)
      switch (name) {
        case 'pscamBuycus':
          var dataInfo = sessionStorage.getItem('selectSupplierData')
          // console.log(dataInfo)
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo)
            this.getRequestData.pscamBuycus = dataInfo.smId
            this.getRequestData.smName = dataInfo.smName

          }
          break;
        default:
          this.sendDataInfo[name] = value

      }

    },



    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path)
      let responseData = await this.$http.getJur({ ids: [pathId.jurId] })
      if (responseData.status == 200) {
        this.pageShowData = responseData.result
        this.formDataList = this.pageShowData.jurFormVoList
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getButtonList()
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    selecDataAction(data) {
      this.selectedDataList = data
    },
    selectDetailsction(data) {
      this.selectDetails = data
    },

    // 动作集合
    actionSet(actionData) {
      switch (actionData.actionType) {
        case 0:
          this.showStatus = true
          this.actionData = {
            cate: 0, formData: this.formDataList,
            oldData: '', orderId: '', printSouce: '',
            printJurId: ''
          }
          break;
        case 1:
          if (!this.returnData.list[this.selectedDataIndex]) {
            this.$message({
              message: '请先选择您要操作的数据',
              type: 'error'
            });
            return false
          }
          var dataInfo = JSON.parse(JSON.stringify(this.returnData.list[this.selectedDataIndex]))
          if (Number(dataInfo.pscamState) > 0) {
            return this.$message({
              message: '非初始化状态不能修改，请重新选择',
              type: 'error'
            });
          }
          this.showStatus = true
          this.actionData = {
            cate: 1, formData: this.formDataList,
            oldData: dataInfo, orderId: dataInfo.pscamId, printSouce: '',
            printJurId: ''
          }
          break;
        case 2:
          this.delDataAction()
          break;
        case 3:
          this.submitData()
          break;
      }
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val
      this.getDataList()
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1
      this.getRequestData.rows = val
      this.getDataList()
    },


    // 获取数据列表
    async getDataList() {

      let responseData = await this.$http.drtchaQuery(this.getRequestData)
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list
        this.returnData.pages = responseData.result.pages
        this.returnData.total = responseData.result.total
        this.returnData.pageNum = responseData.result.pageNum
        this.selectedDataIndex = 0
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },


    // 提交审核
    async submitData() {
      if (!this.returnData.list[this.selectedDataIndex]) {
        this.$message({
          message: '请先选择您要操作的数据',
          type: 'error'
        });
        return false
      }
      var dataInfo = this.returnData.list[this.selectedDataIndex]
      // this.$confirm('确定要提交审核吗？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // }).then(async () => {
      var delData = {
        ids: [dataInfo.drtcamId]
      }
      let responseData = await this.$http.drtchaDrtchaSubmit(delData)
      if (responseData.status == 200) {
        this.$message({
          type: 'success',
          message: '操作成功!'
        });

        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }

      // }).catch(() => { });

    },

    // 删除数据
    delDataAction() {
      if (!this.returnData.list[this.selectedDataIndex]) {
        this.$message({
          message: '请先选择您要操作的数据',
          type: 'error'
        });
        return false
      }
      var dataInfo = this.returnData.list[this.selectedDataIndex]
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        var delData = {
          ids: [dataInfo.drtcamId]
        }
        let responseData = await this.$http.drtchadelete(delData)
        if (responseData.status == 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });

          this.getDataList()
        } else {
          this.$message({
            message: responseData.message,
            type: 'error'
          });
        }

      }).catch(() => { });

    },

    //获取状态
    getIsGsp(str, val) {
      try {
        str && str.replace(/\\/g, '')
        let arr = JSON.parse(str)
        let len = arr.length
        let newStr = ''
        for (let i = 0; i < len; i++) {
          if (arr[i].key === val) {
            newStr = arr[i].value
            break;
          }
        }
        return newStr
      } catch (ex) {
        return str
      }
    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
// 初始化时间
    initTime() {
      this.getRequestData.start = this.$common.getStartTime()
      this.getRequestData.end = this.$common.getEndTime()
    }


  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPageInfo()
    this.initTime()

  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>